<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">コンテナ調整</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="load()" class="btn-search">{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
        <v-btn
          :disabled="
            sourceSelected.length === 0 || currentTargetWarehouse.length === 0
          "
          @click="move()"
          >移動</v-btn
        >
        <v-btn
          @click="replace()"
          :disabled="sourceSelected.length === 0 || targetSelected.length === 0"
          >入れ替え</v-btn
        >
        <v-btn
          v-permit.SHARP_ADJUST_CONTAINER_SETTING_UPDATE
          @click="editLimit()"
          >コンテナ枠変更</v-btn
        >
        <v-btn
          v-permit.SHARP_ADJUST_CONTAINER_SETTING_MASTER_DOWNLOAD
          @click="$refs.downloadDialog.popup()"
          >コンテナ枠実績差異</v-btn
        >
      </v-card-actions>
    </v-card>
    <div class="row">
      <v-card class="card">
        <v-layout>
          <v-flex md3 sm6 xs12 class="search">
            <remote-autocomplete
              label="納入場所"
              url="warehouses/reservable-kv"
              v-model="query.sourceFinallyWarehouseId"
            ></remote-autocomplete>
          </v-flex>
          <v-flex md3 sm6 xs12 class="search">
            <date-picker
              label="納入予定日"
              :min="today"
              v-model="query.sourceForecastDeliveryDate"
            ></date-picker>
          </v-flex>
        </v-layout>
        <table>
          <tr>
            <th></th>
            <th style="text-align: center;">残</th>
            <th
              style="width: 180px"
              @click="sortSourceContainers('containerNo')"
            >
              コンテナＮＯ
            </th>
            <th
              style="width: 80px"
              @click="sortSourceContainers('containerType')"
            >
              サイズ
            </th>
            <th @click="sortSourceContainers('skuCode')" style="width: 150px">
              代表品番/品種
            </th>
            <th @click="sortSourceQty('skuQty')" style="text-align: center">
              台数
            </th>
            <th style="text-align: center">
              陸揚港
            </th>
          </tr>
          <tr
            v-for="source in warehouseDisplaySources"
            :key="source.shipmentId"
          >
            <td
              class="thickLine"
              v-if="source.firstChild"
              :rowspan="(source && source.containerLength) || 1"
            >
              <div>
                {{ source.buName || source.companyCode }}
              </div>
              <div>
                {{ source.businessUnitName }}
              </div>
              <div class="warehouse">
                <span>{{ source.productGroupName }}</span>
                <!-- <v-checkbox
                  @click="selectSourceWarehouse(source)"
                  :value="source"
                  v-model="currentSource"
                /> -->
              </div>
            </td>
            <td
              v-if="source.firstChild"
              :rowspan="(source && source.containerLength) || 1"
              :class="{
                thickLine: true,
                qtyLeft: true,
              }"
            >
              {{ source.upperLimit - source.used || 0 }}
            </td>
            <td
              :class="{
                thickLine: source.lastChild,
                selected: findIfSelected(source, sourceSelected) !== -1,
              }"
            >
              <v-checkbox
                v-model="sourceSelected"
                :label="source.containerNo"
                :value="source"
                :disabled="
                  !source.containerNo ||
                    (sourceSelected.length >= 50 &&
                      sourceSelected.indexOf(source) < 0)
                "
              ></v-checkbox>
            </td>
            <td
              @click="selectSource(source)"
              :class="{
                thickLine: source.lastChild,
                selected: findIfSelected(source, sourceSelected) !== -1,
              }"
            >
              {{ source.containerType }}
            </td>
            <td
              @click="selectSource(source)"
              :class="{
                thickLine: source.lastChild,
                selected: findIfSelected(source, sourceSelected) !== -1,
              }"
            >
              <div>
                {{ source.skuCode }}
              </div>
              <div>
                {{
                  source.productCode
                    ? source.productCode + ':' + source.productName
                    : ''
                }}
              </div>
            </td>
            <td
              @click="selectSource(source)"
              style="text-align: center"
              :class="{
                thickLine: source.lastChild,
                selected: findIfSelected(source, sourceSelected) !== -1,
              }"
            >
              {{ source.skuQty }}
            </td>
            <td
              @click="selectSource(source)"
              style="text-align: center"
              :class="{
                thickLine: source.lastChild,
                selected: findIfSelected(source, sourceSelected) !== -1,
              }"
            >
              {{ source.dischargePortName ? source.dischargePortName : '' }}
            </td>
          </tr>
        </table>
      </v-card>

      <v-card class="card">
        <v-layout>
          <v-flex md3 sm6 xs12 class="search">
            <remote-autocomplete
              label="納入場所"
              url="warehouses/reservable-kv"
              v-model="query.targetFinallyWarehouseId"
            ></remote-autocomplete>
          </v-flex>
          <v-flex md6 sm6 xs12 class="search">
            <v-layout>
              <v-flex md6 pr-2>
                <date-picker
                  label="納入予定日"
                  :min="today"
                  :max="query.targetForecastDeliveryDateTo"
                  v-model="query.targetForecastDeliveryDateFrom"
                ></date-picker>
              </v-flex>
              <v-flex md1 style="margin-top: 15px">~</v-flex>
              <v-flex md5>
                <date-picker
                  :min="query.targetForecastDeliveryDateFrom || today"
                  v-model="query.targetForecastDeliveryDateTo"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-radio-group v-model="currentTargetWarehouse">
          <v-card
            v-show="targetSetting.length > 0"
            v-for="(targetSetting, index) in warehouseDisplayTargets"
            :key="index"
          >
            <table>
              <tr>
                <th>
                  <v-radio :value="targetSetting"></v-radio>
                </th>
                <th style="text-align: center">残</th>
                <th
                  style="width: 180px"
                  @click="sortTargetContainers('containerNo', targetSetting)"
                >
                  コンテナＮＯ
                </th>
                <th
                  style="width: 80px"
                  @click="sortTargetContainers('containerType', targetSetting)"
                >
                  サイズ
                </th>
                <th
                  style="width: 150px"
                  @click="sortTargetContainers('skuCode', targetSetting)"
                >
                  代表品番/品種
                </th>
                <th
                  style="text-align: center"
                  @click="sortTargetQty('skuQty', targetSetting)"
                >
                  台数
                </th>
                <th style="text-align: center">
                  陸揚港
                </th>
              </tr>
              <tr v-for="target in targetSetting" :key="target.shipmentId">
                <td
                  class="thickLine"
                  v-if="target.firstChild"
                  :rowspan="(target && target.containerLength) || 1"
                >
                  <div>
                    {{ target.buName || target.companyCode }}
                  </div>
                  <div>
                    {{ target.businessUnitName }}
                  </div>
                  <div class="warehouse">
                    <span>{{ target.productGroupName }}</span>
                    <!-- <v-checkbox
                  @click="selectTargetWarehouse(target)"
                  :value="target"
                  v-model="currentTarget"
                /> -->
                  </div>
                  <div class="warehouse">
                    <span style="fontSize:12px;">{{ target.date }}</span>
                  </div>
                </td>
                <td
                  v-if="target.firstChild"
                  :rowspan="(target && target.containerLength) || 1"
                  :class="{
                    thickLine: true,
                    qtyLeft: true,
                  }"
                >
                  {{ target.upperLimit - target.used || 0 }}
                </td>
                <td
                  :class="{
                    thickLine: target.lastChild,
                    selected: findIfSelected(target, targetSelected) !== -1,
                  }"
                >
                  <v-checkbox
                    v-model="targetSelected"
                    :label="target.containerNo"
                    :value="target"
                    :disabled="!target.containerNo"
                  ></v-checkbox>
                </td>
                <td
                  @click="selectTarget(target)"
                  :class="{
                    thickLine: target.lastChild,
                    selected: findIfSelected(target, targetSelected) !== -1,
                  }"
                >
                  {{ target.containerType }}
                </td>
                <td
                  @click="selectTarget(target)"
                  :class="{
                    thickLine: target.lastChild,
                    selected: findIfSelected(target, targetSelected) !== -1,
                  }"
                >
                  <div>
                    {{ target.skuCode }}
                  </div>
                  <div>
                    {{
                      target.productCode
                        ? target.productCode + ':' + target.productName
                        : ''
                    }}
                  </div>
                </td>
                <td
                  @click="selectTarget(target)"
                  :class="{
                    thickLine: target.lastChild,
                    selected: findIfSelected(target, targetSelected) !== -1,
                  }"
                  style="text-align: center"
                >
                  {{ target.skuQty }}
                </td>
                <td
                  @click="selectTarget(target)"
                  :class="{
                    thickLine: target.lastChild,
                    selected: findIfSelected(target, targetSelected) !== -1,
                  }"
                  style="text-align: center"
                >
                  {{ target.dischargePortName ? target.dischargePortName : '' }}
                </td>
              </tr>
            </table>
          </v-card>
        </v-radio-group>
      </v-card>
    </div>
    <edit-dialog @refresh="load" ref="editDialog" />
    <download-dialog :dif="true" :employee="this.user" ref="downloadDialog" />
  </v-container>
</template>

<script>
import DateFormat from 'dateformat'
import EditDialog from '../M0290/EditDialog'
import DownloadDialog from '../M0290/DownloadDialog'
export default {
  components: {
    EditDialog,
    DownloadDialog,
  },
  methods: {
    validSelected() {
      if (this.sourceSelected.length > 50) {
        this.$message('', 'selected must less than 50')
        return false
      }
      return true
    },
    editLimit() {
      this.$refs.editDialog.popup()
    },
    addDate(date, days) {
      var d = new Date(date)
      d.setDate(d.getDate() + days)
      var m = d.getMonth()
      return new Date(d.getFullYear(), m, d.getDate()).format('yyyy-MM-dd')
    },
    initData() {
      this.today = DateFormat(new Date(), 'yyyy-mm-dd')
    },
    load() {
      this.targetSelected = []
      this.sourceSelected = []
      this.warehouseSources = []
      this.warehouseTargets = []
      this.warehouseDisplaySources = []
      this.warehouseDisplayTargets = []
      this.dateRange = []
      if (
        this.query.sourceFinallyWarehouseId &&
        this.query.sourceForecastDeliveryDate
      ) {
        this.loadSourceByWarehouse()
      }
      if (
        this.query.targetFinallyWarehouseId &&
        this.query.targetForecastDeliveryDateFrom &&
        this.query.targetForecastDeliveryDateTo
      ) {
        var startDate = this.query.targetForecastDeliveryDateFrom
        var endDate = this.query.targetForecastDeliveryDateTo
        do {
          this.loadTargetByWarehouse(startDate)
          this.dateRange.push(startDate)
          startDate = this.addDate(startDate, 1)
        } while (startDate <= endDate)
      }
    },
    loadSourceByWarehouse() {
      var warehouseId = this.query.sourceFinallyWarehouseId
      var date = this.query.sourceForecastDeliveryDate

      this.$http
        .get(
          `/warehouse-container-settings/warehouse`,
          this.params(warehouseId, date)
        )
        .then((res) => {
          this.warehouseSources = res.data
          this.loadSourceContainers(warehouseId, date)
        })
    },
    loadTargetByWarehouse(date) {
      var warehouseId = this.query.targetFinallyWarehouseId

      return this.$http
        .get(
          `/warehouse-container-settings/warehouse`,
          this.params(warehouseId, date)
        )
        .then((res) => {
          this.warehouseTargets.push(res.data)
          this.loadTargetContainers(res.data, warehouseId, date).then(() => {
            this.warehouseDisplayTargets = this.warehouseDisplayTargets.sort(
              (a, b) => {
                return (
                  (a.length > 0 && a[0].date) ||
                  '2999-12-31'
                ).localeCompare((b.length > 0 && b[0].date) || '2999-12-31')
              }
            )
            this.targetSelected = []
            this.currentTargetWarehouse = []
          })
        })
    },
    loadSourceContainers(warehouseId, date) {
      this.$http
        .get(
          `/warehouse-container-settings/source-shipments`,
          this.params(warehouseId, date)
        )
        .then((res) => {
          var warehouseDisplaySources = []
          var containers = res.data
          this.warehouseSources.forEach((setting, groupIndex) => {
            setting.groupIndex = groupIndex
            var wCtns = containers.filter((c) => {
              return setting.id === c.warehouseConfigId
            })
            var ctnLength = wCtns.length

            if (ctnLength === 0) {
              warehouseDisplaySources.push({
                ...setting,
                containerLength: ctnLength,
                firstChild: true,
                lastChild: true,
              })
            }
            wCtns.forEach((ctn, index) => {
              if (index === 0) {
                ctn.firstChild = true
              } else if (index === ctnLength - 1) {
                ctn.lastChild = true
              }
              if (ctnLength === 1) {
                ctn.firstChild = true
                ctn.lastChild = true
              }
              ctn.index = index
              setting.checked = true
              warehouseDisplaySources.push({
                ...setting,
                containerNo: ctn.containerNo,
                containerType: ctn.containerType,
                skuCode: ctn.skuCode,
                productCode: ctn.productCode,
                productName: ctn.productName,
                shipmentProductGroupName: ctn.productGroupName,
                shipmentId: ctn.shipmentId,
                firstChild: ctn.firstChild,
                lastChild: ctn.lastChild,
                index: ctn.index,
                containerLength: ctnLength,
                warehouseConfigId: ctn.warehouseConfigId,
                skuQty: ctn.skuQty,
                buCode: ctn.buCode,
                buId: ctn.buId,
                shipmentBusinessUnitId: ctn.businessUnitId,
                shipmentBusinessUnitCode: ctn.businessUnitCode,
                dischargePortCode: ctn.dischargePortCode,
                dischargePortName: ctn.dischargePortName,
              })
            })
          })
          this.warehouseDisplaySources = warehouseDisplaySources
          this.sourceSelected = []
        })
    },
    loadTargetContainers(settings, warehouseId, date) {
      return this.$http
        .get(
          `/warehouse-container-settings/source-shipments`,
          this.params(warehouseId, date)
        )
        .then((res) => {
          var warehouseDisplayTargets = []
          var containers = res.data

          settings.forEach((setting, groupIndex) => {
            setting.groupIndex = groupIndex
            var wCtns = containers.filter((c) => {
              return setting.id === c.warehouseConfigId
            })
            var ctnLength = wCtns.length

            if (ctnLength === 0) {
              warehouseDisplayTargets.push({
                ...setting,
                containerLength: ctnLength,
                firstChild: true,
                lastChild: true,
              })
            }
            wCtns.forEach((ctn, index) => {
              if (index === 0) {
                ctn.firstChild = true
              } else if (index === ctnLength - 1) {
                ctn.lastChild = true
              }
              if (ctnLength === 1) {
                ctn.firstChild = true
                ctn.lastChild = true
              }
              ctn.index = index
              setting.checked = true
              warehouseDisplayTargets.push({
                containerNo: ctn.containerNo,
                containerType: ctn.containerType,
                skuCode: ctn.skuCode,
                productCode: ctn.productCode,
                productName: ctn.productName,
                shipmentProductGroupName: ctn.productGroupName,
                shipmentId: ctn.shipmentId,
                firstChild: ctn.firstChild,
                lastChild: ctn.lastChild,
                ...setting,
                index: ctn.index,
                containerLength: ctnLength,
                warehouseConfigId: ctn.warehouseConfigId,
                skuQty: ctn.skuQty,
                buCode: ctn.buCode,
                buId: ctn.buId,
                shipmentBusinessUnitId: ctn.businessUnitId,
                shipmentBusinessUnitCode: ctn.businessUnitCode,
                dischargePortCode: ctn.dischargePortCode,
                dischargePortName: ctn.dischargePortName,
              })
            })
          })
          this.warehouseDisplayTargets.push(warehouseDisplayTargets)
          this.targetSelected = []
        })
    },

    params(warehouseId, date) {
      return {
        params: {
          reserveDate: date,
          warehouseId: warehouseId,
        },
      }
    },

    sortSourceContainers(sortField) {
      console.log('do nothing')
      //doNothing
      // var sortedData = this.warehouseDisplaySources.sort((c1, c2) =>
      //   (c1[sortField] || '').localeCompare(c2[sortField] || '')
      // )
      // this.warehouseDisplaySources = [...this.buildData(sortedData)]
    },
    sortSourceQty(sortField) {
      console.log('do nothing')
      //doNothing
      // var sortedData = this.warehouseDisplaySources.sort(
      //   (c1, c2) => c1[sortField] - c2[sortField]
      // )
      // this.warehouseDisplaySources = [...this.buildData(sortedData)]
    },

    sortTargetContainers(sortField, targetSetting) {
      console.log('do nothing')
      //doNothing
      // var sortedData = targetSetting.sort((c1, c2) =>
      //   (c1[sortField] || '').localeCompare(c2[sortField] || '')
      // )
      // targetSetting = [...this.buildData(sortedData)]
    },
    sortTargetQty(sortField, targetSetting) {
      console.log('do nothing')
      //doNothing
      // var sortedData = targetSetting.sort(
      //   (c1, c2) => c1[sortField] - c2[sortField]
      // )
      // targetSetting = [...this.buildData(sortedData)]
    },

    buildData(sortedData) {
      var emptySetting = []
      var nonEmptySetting = []
      for (var i = 0; i < sortedData.length; i++) {
        var data = sortedData.filter((s) => s.groupIndex === i)

        if (data.length === 1 && data[0].containerLength === 0) {
          emptySetting = [...emptySetting, ...data]
        }

        if (data.length === 1 && data[0].containerLength === 1) {
          nonEmptySetting.push(data[0])
        }

        if (data.length > 1) {
          for (var j = 0; j < data.length; j++) {
            if (j === 0) {
              data[j].firstChild = true
              data[j].lastChild = false
            } else if (j === data.length - 1) {
              data[j].lastChild = true
              data[j].firstChild = false
            } else {
              data[j].firstChild = false
              data[j].lastChild = false
            }
            nonEmptySetting.push(data[j])
          }
        }
      }
      return [...nonEmptySetting, ...emptySetting]
    },

    findIfSelected(container, data) {
      return data.indexOf(container)
    },

    selectTarget(target) {
      if (!target.containerNo) {
        return
      }
      var index = this.findIfSelected(target, this.targetSelected)
      if (index === -1) {
        this.targetSelected.push(target)
      } else {
        this.targetSelected.splice(index, 1)
      }
      // this.selectTargetWarehouse(target)
    },

    selectSource(source) {
      if (!source.containerNo) {
        return
      }
      var index = this.findIfSelected(source, this.sourceSelected)
      if (index === -1) {
        this.sourceSelected.push(source)
      } else {
        this.sourceSelected.splice(index, 1)
      }
      // this.selectSourceWarehouse(source)
    },

    selectSourceWarehouse(source) {
      if (this.currentSource.length === 0) {
        this.currentSource.push(source)
      }
      if (this.currentSource[0].id !== source.id) {
        this.currentSource = []
        this.currentSource.push(source)
      }
    },
    selectTargetWarehouse(target) {
      if (this.currentTarget.length === 0) {
        this.currentTarget.push(target)
      }
      if (this.currentTarget[0].id !== target.id) {
        this.currentTarget = []
        this.currentTarget.push(target)
      }
    },
    getEmployee() {
      this.$http.get(`/employees/current`).then((res) => {
        this.user = res.data
      })
    },

    difBu() {
      return (
        !this.isSjl &&
        this.user.careBu &&
        (this.sourceSelected.filter(
          (s) => s.shipmentBusinessUnitId !== this.user.businessUnitId
        ).length > 0 ||
          this.targetSelected.filter(
            (s) => s.shipmentBusinessUnitId !== this.user.businessUnitId
          ).length > 0)
      )
    },

    move() {
      if (!this.validSelected()) {
        return
      }
      var results = []
      if (this.difBu()) {
        this.$message(
          '',
          '操作者が属するBU以外のデータを操作するのは許可されません。'
        )
        return
      }
      var emptyResource = false

      this.sourceSelected.forEach((s, index) => {
        var targetResource = this.currentTargetWarehouse.find((w) => {
          return (
            w.buId === s.buId &&
            (this.user.careBu
              ? w.businessUnitId === s.shipmentBusinessUnitId
              : true) &&
            w.productGroupName === s.shipmentProductGroupName &&
            w.upperLimit - w.used > 0
          )
        })

        if (!targetResource) {
          targetResource = this.currentTargetWarehouse.find((w) => {
            return (
              w.buId === s.buId &&
              (this.user.careBu
                ? w.businessUnitId === s.shipmentBusinessUnitId
                : true) &&
              w.upperLimit - w.used > 0
            )
          })
        }

        if (!targetResource) {
          targetResource = this.currentTargetWarehouse.find((w) => {
            return w.companyCode === 'SJL' && w.upperLimit - w.used > 0
          })
        }

        if (!targetResource) {
          emptyResource = true
        }

        targetResource.used += 1

        results.push({
          shipmentId: s.shipmentId,
          resourceId: s.warehouseConfigId,
          bookingCode: targetResource && targetResource.warehouseId,
          targetResourceCode: targetResource && targetResource.id,
          targetResDate: targetResource && targetResource.date,
          businessObject: s.shipmentId,
        })
      })

      if (emptyResource) {
        this.$message('', '予約可能倉庫が見つかりません。')
        return
      }

      this.$http
        .put(`/warehouse-container-settings/replace`, results)
        .then((res) => {
          this.load()
          if (res.data.success) {
            this.$message('', '移動しました。')
          } else {
            this.$message('', '移動できません。:' + res.data.localeMessage)
          }
          console.log(res.data)
        })
        .catch((err) => {
          this.load()
          this.$showError(err)
        })
    },

    replace() {
      if (this.validSelected()) {
        return
      }
      var firstDate = this.targetSelected[0].date
      var difDate = this.targetSelected.find((t) => t.date !== firstDate)
      if (difDate) {
        this.$message(
          '',
          '複数コンテナを置換る場合は右側で選択したコンテナの納入予定日が同日になければなりません。'
        )
        return
      }

      var results = []

      var sourceSize = this.sourceSelected.length
      var targetSize = this.targetSelected.length

      var source20F = this.sourceSelected.filter(
        (s) => s.containerType === '20F'
      )

      var source40F = this.sourceSelected.filter(
        (s) => s.containerType === '40F'
      )

      var target20F = this.targetSelected.filter(
        (s) => s.containerType === '20F'
      )

      var target40F = this.targetSelected.filter(
        (s) => s.containerType === '40F'
      )

      if (
        ((source20F.length > 0 && target40F.length > 0) ||
          (source40F.length > 0 && target20F.length > 0)) &&
        !this.isSjl
      ) {
        this.$message('', '40Fと20Fコンテナの入替は、SJL担当者しかできません。')
        return
      }
      if (sourceSize > 0 && targetSize > 0 && sourceSize !== targetSize) {
        this.$message(
          '',
          '入替え対象のコンテナ数量が一致していないので、入替えできません。'
        )
        return
      }

      if (this.difBu()) {
        this.$message(
          '',
          '操作者が属するBU以外のデータを操作するのは許可されません。'
        )
        return
      }

      var emptyResource = false

      this.sourceSelected.forEach((s) => {
        var sourceRes = this.warehouseSources.find((w) => w.id === s.id)
        sourceRes.used -= 1
      })

      this.targetSelected.forEach((t) => {
        var warehouseTargets = this.warehouseTargets.find(
          (r) => r[0].date === t.date
        )
        var targetRes = warehouseTargets.find((w) => w.id === t.id)
        targetRes.used -= 1
      })

      this.sourceSelected.forEach((s, index) => {
        var targetDate = this.targetSelected[0].date
        var warehouseTargets = this.warehouseTargets.find(
          (r) => r[0].date === targetDate
        )
        var targetResource = warehouseTargets.find((w) => {
          return (
            (w.buId === s.buId || w.companyCode === 'SJL') &&
            (this.user.careBu
              ? w.businessUnitId === s.shipmentBusinessUnitId
              : true) &&
            w.productGroupName === s.shipmentProductGroupName &&
            w.upperLimit - w.used > 0
          )
        })

        if (!targetResource) {
          targetResource = warehouseTargets.find((w) => {
            return (
              (w.buId === s.buId || w.companyCode === 'SJL') &&
              (this.user.careBu
                ? w.businessUnitId === s.shipmentBusinessUnitId
                : true) &&
              w.upperLimit - w.used > 0
            )
          })
        }

        if (!targetResource) {
          var targetSelect = this.targetSelected[index]
          console.log('targetSelect', targetSelect)
          targetResource = warehouseTargets.find(
            (w) => w.id === targetSelect.warehouseConfigId
          )
          console.log(targetResource)
        }

        if (!targetResource) {
          emptyResource = true
        }

        targetResource.used += 1

        results.push({
          shipmentId: s.shipmentId,
          resourceId: s.warehouseConfigId,
          bookingCode: targetResource && targetResource.warehouseId,
          targetResourceCode: targetResource && targetResource.id,
          targetResDate: targetResource && targetResource.date,
          businessObject: s.shipmentId,
        })
      })

      this.targetSelected.forEach((s, index) => {
        var sourceResource = this.warehouseSources.find((w) => {
          return (
            (w.buId === s.buId || w.companyCode === 'SJL') &&
            (this.user.careBu
              ? w.businessUnitId === s.shipmentBusinessUnitId
              : true) &&
            w.productGroupName === s.shipmentProductGroupName &&
            w.upperLimit - w.used > 0
          )
        })

        if (!sourceResource) {
          sourceResource = this.warehouseSources.find((w) => {
            return (
              (w.buId === s.buId || w.companyCode === 'SJL') &&
              (this.user.careBu
                ? w.businessUnitId === s.shipmentBusinessUnitId
                : true) &&
              w.upperLimit - w.used > 0
            )
          })
        }

        if (!sourceResource) {
          var sourceSelect = this.sourceSelected[index]
          sourceResource = this.warehouseSources.find(
            (w) => w.id === sourceSelect.warehouseConfigId
          )
        }

        if (!sourceResource) {
          emptyResource = true
        }

        sourceResource.used += 1

        results.push({
          shipmentId: s.shipmentId,
          resourceId: s.warehouseConfigId,
          bookingCode: sourceResource && sourceResource.warehouseId,
          targetResourceCode: sourceResource && sourceResource.id,
          targetResDate: sourceResource && sourceResource.date,
          businessObject: s.shipmentId,
        })
      })

      console.log(results)

      if (emptyResource) {
        this.$message('', '予約可能倉庫が見つかりません。')
        return
      }

      this.$http
        .put(`/warehouse-container-settings/replace`, results)
        .then((res) => {
          this.load()
          if (res.data.success) {
            this.$message('', '移動しました。')
          } else {
            this.$message('', '移動できません。:' + res.data.localeMessage)
          }
          console.log(res.data)
        })
        .catch((err) => {
          this.load()
          this.$showError(err)
        })
    },
  },
  data() {
    return {
      currentTargetWarehouse: [],
      user: {},
      today: null,
      warehouseDisplaySources: [],
      warehouseDisplayTargets: [],
      warehouseSources: [],
      warehouseTargets: [],
      currentSource: [],
      currentTarget: [],
      sourceContainers: [],
      targetContainers: [],
      results: [],
      targetResults: [],
      loading: false,
      query: {},
      sourceSelected: [],
      targetSelected: [],
      selected: [],
      pagination: {
        page: 0,
      },
      headers: [
        {
          text: 'コンテナＮＯ',
          sortable: true,
        },
        {
          text: 'コンテナサイズ',
          sortable: true,
        },
        {
          text: '代表品番',
          sortable: true,
        },
        {
          text: '代表品番台数',
          sortable: true,
        },
        {
          text: '品種名',
          sortable: true,
        },
      ],
      differentWarehouse: false,
      errors: {
        NOT_IN_AVAILDAYS: '選択した納入予定日が正常納入指示範囲にありません。',
        ONLY_SJL_CAN_MOVE_EXCEPTION:
          'SJL様しか例外納入指示承認済みのコンテナを移動できません。',
        INVALID_STATUS:
          '納入場所確定と納入指示済み状態になるコンテナしか移動できません。',
        WITH_LONG_DISTANCE:
          'コンテナ調整：選択されたデータはロングドレジの納入指示なので、明細画面にご予約ください。',
        MOVE_ERROR: 'BUを超えて移動できません。',
      },
      dateRange: [],
    }
  },
  mounted() {
    this.$loadParams()
    this.initData()
    this.getEmployee()
  },
  computed: {
    valid() {
      return (
        this.query.sourceFinallyWarehouseId &&
        this.query.targetFinallyWarehouseId &&
        this.query.sourceForecastDeliveryDate &&
        this.query.targetForecastDeliveryDateFrom &&
        this.query.targetForecastDeliveryDateTo
      )
    },
    isSjl() {
      return this.user.companyName === 'SJL'
    },
  },
  watch: {
    'query.sourceFinallyWarehouseId'() {
      if (!this.query.targetFinallyWarehouseId) {
        this.$set(
          this.query,
          'targetFinallyWarehouseId',
          this.query.sourceFinallyWarehouseId
        )
      }
    },
  },
}
</script>

<style scoped>
.cardText {
  display: flex;
}

.ctn {
  display: flex;
}

.loadDate {
  display: flex;
  height: 50px;
  align-items: center;
}

.ctnCheckBox {
  display: flex;
  height: 50px;
  align-items: center;
  margin: 0 0 0 10px;
}

.ctnNo {
  display: flex;
  height: 50px;
  align-items: center;
  margin: 0 10px 0 5px;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

table td {
  border-bottom: 1px dashed #ccc;
  padding: 3px 0px;
  white-space: normal;
  border-left: hidden;
  border-right: hidden;
}

table th {
  text-align: left;
  border-bottom: 1px solid #eee;
}

.ctns {
  white-space: normal;
}

.line {
  border: 1px solid black;
}

.search {
  margin-left: 20px;
}

.cardStyle {
  margin-top: 10px;
  padding: 0 10px 15px 10px;
  width: 95%;
  display: flex;
  /* min-height: 200px; */
}

.qtyLeft {
  text-align: center;
  font-size: 24px;
  color: red;
}

.insideTable {
  width: 100%;
  border: hidden !important;
}

.thickLine,
.thickLine.selected {
  border-bottom: 2px red solid;
}

.selected {
  background-color: rgb(253, 193, 9);
  color: white;
  border-bottom: 1px dashed white;
}

.warehouse {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.warehouse /deep/ .v-input {
  flex: none;
}

.warehouse /deep/ .v-messages {
  display: none;
}

.warehouse /deep/ .v-input--selection-controls__input {
  margin: 0px;
  padding: 0px;
}

.warehouse /deep/ .v-input {
  margin: 0px;
  padding: 0px;
}

.warehouse /deep/ .v-input--selection-controls__ripple {
  padding: 0px;
  margin: 0px;
}

.row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  vertical-align: top;
  padding: 15px 0px;
}

.card {
  box-sizing: border-box;
  padding: 15px;
  min-width: 50%;
}

.card + .card {
  margin-left: 15px;
  margin-top: 0px !important;
}

.row table {
  width: 100%;
}
</style>
